import { render, staticRenderFns } from "./PondOverview.vue?vue&type=template&id=5754c054"
import script from "./PondOverview.vue?vue&type=script&lang=js"
export * from "./PondOverview.vue?vue&type=script&lang=js"
import style0 from "./PondOverview.vue?vue&type=style&index=0&id=5754c054&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QBtn,QSeparator,QCardSection,QIcon});
